<template>
    <div class="sysConfig">
      <el-row :gutter="20" class="title">
        <el-col :span="6">功能</el-col>
        <el-col :span="6">说明</el-col>
        <el-col :span="6">状态</el-col>
        <el-col :span="6">操作</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">微信开放平台绑定</el-col>
        <el-col :span="6" style="color: #999">授权后可使用微信高级管理功能</el-col>
        <el-col :span="6">{{wechatStatus}}</el-col>
        <el-col :span="6"><el-button size="mini" round @click="editSysConfig">{{wechatStatus == "已授权" ? "修改" : "授权"}}</el-button></el-col>
      </el-row>
      <!--<el-row :gutter="20">-->
        <!--<el-col :span="6">风格自定义</el-col>-->
        <!--<el-col :span="6" style="color: #999">自定义 系统LOGO</el-col>-->
        <!--<el-col :span="6">未设置</el-col>-->
        <!--<el-col :span="6"><el-button size="mini" round>设置</el-button></el-col>-->
      <!--</el-row>-->
      <el-row :gutter="20">
        <el-col :span="6">短信接口</el-col>
        <el-col :span="6" style="color: #999">拥有此权限，可以发送短信通知</el-col>
        <el-col :span="6">未设置</el-col>
        <el-col :span="6"><el-button size="mini" round>设置</el-button></el-col>
      </el-row>
      <el-dialog
        title="绑定微信开发平台设置"
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose">
        <el-form ref="sysConfig" :model="sysConfig" label-width="120px">
          <el-form-item label="APPID:">
            <el-input v-model="sysConfig.appid"></el-input>
          </el-form-item>
          <el-form-item label="APPSECRET:">
            <el-input v-model="sysConfig.appsecret"></el-input>
          </el-form-item>
          <el-form-item label="KEY:">
            <span>yhjiu82765892hytr7765whytr678uy65432yw8hyt5</span>
          </el-form-item>
          <el-form-item label="TOKEN:">
            <span>mumecard</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="editSysConfigSure">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import utils from "../utils/utils";
  export default {
    name: "sys-config",
    data(){
      return{
        sysConfig:{
          appid:"",
          appsecret:""
        },
        wechatStatus:"",
        dialogVisible:false,
      }
    },
    created(){
      this.getSysConfig()
    },
    methods:{
      getSysConfig(){
        utils.axiosMethods({
          method:"GET",
          url:"/api/sysConfig/query",
          callback:(res => {
            if(res.data.code == 0){
              this.sysConfig.appid = res.data.obj.appid;
              this.sysConfig.appsecret = res.data.obj.appsecret;
              if(res.data.obj.appid && res.data.obj.appsecret){
                this.wechatStatus = "已授权"
              }else{
                this.wechatStatus = "未授权"
              }
            }
          })
        })
      },
      handleClose(){
        this.getSysConfig();
        this.dialogVisible = false;
      },
      editSysConfig(){
        this.dialogVisible = true;
      },
      editSysConfigSure(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/sysConfig/update",
          data:this.sysConfig,
          callback:(res => {
            if(res.data.code == 0){
              this.sysConfig.appid = res.data.obj.appid;
              this.sysConfig.appsecret = res.data.obj.appsecret;
              if(res.data.obj.appid && res.data.obj.appsecret){
                this.wechatStatus = "已授权"
              }else{
                this.wechatStatus = "未授权"
              }
              this.dialogVisible = false;
              this.$message.success("授权成功")
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .sysConfig{
    text-align: center;
    line-height: 60px;
    font-size: 14px;
    .title{
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sysConfig.vue